/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'confluence.error.panel.refresh.app': 'Refresh app',
  'confluence.error.panel.reload.page': 'Reload page',
  'confluence.icon.label': 'Icon',
  'confluence.modal.dialog.close.modal.button': 'Cancel',
  'confluence.select.required.field.message': 'This field is required.',
  'confluence.text.area.required.field.message': 'This field is required.',
  'confluence.textfield.validator.email': 'Enter a valid email.',
  'confluence.textfield.validator.number': 'Enter a valid number',
  'confluence.textfield.validator.required.field.message': 'This field is required.',
  'confluence.textfield.validator.telephone': 'Enter a valid telephone.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Access required',
  'confluence.threeLOPrompt.modal.error.title': 'Error',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'Consent URL not found. Please refresh the page and try again.',
  'confluence.threeLOPrompt.no.authURL.error-message': 'Consent URL not found. Please refresh the page and try again.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Allow access',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Configure access',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Failed to authenticate.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    'For {appString} to display, you need to allow the app to access Atlassian products on your behalf.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message-appify':
    'For {appString} to display, you need to grant it access to Atlassian apps on your behalf.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    '{appString} requires additional access to your account.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'External Auth Warning',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'this app',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'This app',
  'confluence.user.group.unknown.user.message': 'Unknown User',
  'confluence.user.picker.empty.field.error.message': 'This field is required.',
  'confluence.user.unknown.user.message': 'Unknown User',
  'forge-ui.form.submit-button.text': 'Submit',
  'forge.modal.deprecation.message':
    'Your app {appName} uses the deprecated modal editing experience for custom fields, which is being phased out. Please have your system admin update the app to use inline editing instead. If issues remain, contact the app developer.',
  'forge.modal.deprecation.title': 'Update your app',
};
